import { useCallback, useContext } from "react";
import { AsyncActionType } from "../store/actions/types";
import { ChatServer } from "../xapp/ChatServer";
import { ChatServerContext } from "../xapp/XappChat";
import { useChatDispatch } from "./useChatDispatch";

export type ChatServerAsyncActionType = (chatServer: ChatServer) => AsyncActionType;
export type ChatServerDispatch = (action: ChatServerAsyncActionType) => void;

export function useChatServerDispatch(): ChatServerDispatch {

    const inner = useChatDispatch();
    const chatServer = useContext(ChatServerContext);

    return useCallback<ChatServerDispatch>((action: ChatServerAsyncActionType) => {
        if (!action) {
            console.warn("react bug? Someone invokes with null");
            return;
        }
        if (chatServer) {
            inner(action(chatServer));
        }
    }, [inner, chatServer]);
}
